<div class="perfil" appArrastarFecharSheet [arrastarHabilitado]="!sobreposicao()" (arrastouParaFechar)="fechar()">
  <header class="perfil-topo">
    <button type="button" class="perfil-btn-icone" aria-label="Voltar" (click)="fechar()">
      <img src="./assets/icones/redesign/button/icon-back-title-button.svg" alt="" class="perfil-icone-voltar" />
    </button>
    <span class="perfil-topo-titulo">Perfil do contato</span>
    <button type="button" class="perfil-btn-icone" [attr.aria-label]="contato.favorito ? 'Remover dos importantes' : 'Marcar como importante'"
            (click)="alternarFavorito()">
      <img [src]="contato.favorito ? './assets/icones/redesign/modulos/chat/filter/filter-fav-golden.svg' : './assets/icones/redesign/modulos/chat/filter/filter-fav-gray.svg'" alt="" />
    </button>
    <button type="button" class="perfil-btn-icone" aria-label="Editar contato" (click)="editarContato()">
      <img src="./assets/icones/redesign/table/icon-edit-table.svg" alt="" />
    </button>
  </header>

  <div class="perfil-fixo">
    <section class="perfil-identidade">
      <div class="perfil-identidade-corpo">
        <img class="perfil-avatar" [class.perfil-avatar-foto]="possuiFotoPerfil" [src]="fotoContato" alt="" (error)="marcarFotoIndisponivel()" />
        <div class="perfil-identidade-dados">
          <div class="perfil-nome-linha">
            <span class="perfil-nome" [title]="contato.nome || contato.contato">{{ contato.nome || contato.contato }}</span>
          </div>
          @if (carregando()) {
            <span class="skeleton perfil-skeleton-linha" style="width: 120px"></span>
          } @else {
            <span class="perfil-status" [class]="'perfil-status perfil-status-' + statusAtendimento.classe">
              <span class="perfil-status-bolinha"></span>{{ statusAtendimento.texto }}
            </span>
          }
          <span class="perfil-contato-info">{{ ocultarNumero() ? '•••• ••••' : (contato.numero | celularMask) }}</span>
          @if (email) {
            <span class="perfil-contato-info perfil-contato-email">{{ email }}</span>
          }
        </div>
      </div>
    </section>

    <nav class="perfil-abas">
      <button type="button" class="perfil-aba" [class.perfil-aba-ativa]="aba() === 'detalhes'" (click)="clicarAba('detalhes')">Detalhes</button>
      <button type="button" class="perfil-aba" [class.perfil-aba-ativa]="aba() === 'historico'" (click)="clicarAba('historico')">Histórico</button>
      <button type="button" class="perfil-aba" [class.perfil-aba-ativa]="aba() === 'lembretes'" (click)="clicarAba('lembretes')">Lembretes</button>
    </nav>
  </div>

  <div class="perfil-conteudo" #conteudo (scroll)="aoRolarConteudo()"
      appArrastarAbas [podeAnterior]="aba() !== 'detalhes'" [podeProxima]="aba() !== 'lembretes'"
      (abaAnterior)="abaVizinha(-1)" (proximaAba)="abaVizinha(1)">

    @if (aba() === 'detalhes') {
      <section class="perfil-card">
        <span class="perfil-card-titulo">Resumo do Atendimento</span>
        @if (carregando()) {
          @for (linha of [1, 2, 3, 4, 5, 6]; track linha) {
            <span class="skeleton perfil-skeleton-linha"></span>
          }
        } @else {
          @if (sessaoAtual(); as sessao) {
          <dl class="perfil-resumo">
            <dt>Canal</dt><dd>{{ rotuloIdNome(sessao.canal) }}</dd>
            <dt>Fluxo</dt><dd>{{ rotuloIdNome(sessao.fluxo) }}</dd>
            <dt>Etapa Fluxo</dt><dd>{{ rotuloIdNome(sessao.etapa) }}</dd>
            <dt>Operador</dt><dd>{{ sessao.operador?.nome || '-' }}</dd>
            <dt>Nº. Recepção</dt><dd>{{ numeroRecepcao(sessao) }}</dd>
            <dt>T. para Finalização</dt>
            <dd>
              @if (sessao.ativo && sessao.dataFormatadaFinalizar && sessao.dataFormatadaFinalizar !== '00:00') {
                <span class="perfil-prazo">
                  <span class="perfil-prazo-barra" [style.width.%]="larguraPrazo(sessao.tempoFinalizar)"
                        [style.background-color]="corPrazo(sessao.tempoFinalizar)">{{ sessao.dataFormatadaFinalizar }}</span>
                </span>
              } @else {
                Finalizada
              }
            </dd>
            <dt>Data Abertura</dt><dd>{{ sessao.dataAbertura ? (sessao.dataAbertura | date: 'dd/MM/yyyy - HH:mm') : '-' }}</dd>
            <dt>Última Interação</dt><dd>{{ sessao.ultimaInteracao ? (sessao.ultimaInteracao | date: 'dd/MM/yyyy - HH:mm') : '-' }}</dd>
          </dl>
          } @else {
            <span class="perfil-vazio">Este contato ainda não teve sessões.</span>
          }
        }
      </section>

      <section class="perfil-card perfil-acoes">
        <span class="perfil-card-titulo">Ações Rápidas</span>
        <button type="button" class="perfil-acao" [disabled]="carregando() || !sessaoAtiva()" (click)="abrirTransferencia()">
          <img src="./assets/icones/redesign/modulos/chat/details-contato/transfer-contact.svg" alt="" class="perfil-acao-icone" />
          <span>Transferir</span>
          <img src="./assets/icones/redesign/perfil-contato/acao-seta.svg" alt="" class="perfil-acao-seta" />
        </button>
        @if (mostraEncerraAtendimento) {
          <button type="button" class="perfil-acao" (click)="encerrarAtendimento()">
            <img src="./assets/icones/redesign/modulos/chat/details-contato/encerrar-atendimento.svg" alt="" class="perfil-acao-icone" />
            <span>Encerrar Atendimento</span>
            <img src="./assets/icones/redesign/perfil-contato/acao-seta.svg" alt="" class="perfil-acao-seta" />
          </button>
        }
        @if (sessaoAtiva()) {
          <button type="button" class="perfil-acao" (click)="encerrarSessao()">
            <img src="./assets/icones/redesign/modulos/chat/details-contato/message-square-off.svg" alt="" class="perfil-acao-icone perfil-acao-icone-compacto" />
            <span>Encerrar Sessão</span>
            <img src="./assets/icones/redesign/perfil-contato/acao-seta.svg" alt="" class="perfil-acao-seta" />
          </button>
        }
        <button type="button" class="perfil-acao perfil-acao-lembrete" [class.perfil-em-foco]="lembreteEmFoco() && !lembretesHoje().length" (click)="criarLembrete()">
          <img src="./assets/icones/redesign/modulos/chat/details-contato/create-lembrete.svg" alt="" class="perfil-acao-icone" />
          <span>Criar Lembrete</span>
          <img src="./assets/icones/redesign/perfil-contato/acao-seta.svg" alt="" class="perfil-acao-seta" />
        </button>
      </section>

      @if (carregandoLembrete()) {
        <span class="skeleton perfil-skeleton-card perfil-skeleton-lembrete"></span>
      } @else if (lembretesHoje().length) {
        <section class="perfil-card perfil-lembrete" [class.perfil-em-foco]="lembreteEmFoco()">
          <div class="perfil-lembrete-cabecalho">
            <span class="perfil-card-titulo">Lembretes do dia</span>
            <span class="perfil-lembrete-contador">{{ indiceLembrete() + 1 }} de {{ totalLembretesHoje() }}</span>
          </div>
          <app-carrossel [itens]="lembretesHoje()" rotuloIndicador="Ir para o lembrete" (indiceMudou)="aoMudarLembreteHoje($event)">
            <ng-template let-lembrete>
              <app-card-lembrete-contato [lembrete]="lembrete"></app-card-lembrete-contato>
            </ng-template>
          </app-carrossel>
        </section>
      }
    } @else if (aba() === 'lembretes') {
      <section class="perfil-lembretes">
        <div class="perfil-lembretes-filtros">
          <button type="button" class="perfil-filtro-lembrete" [class.perfil-filtro-lembrete-ativo]="filtroLembretes() === 'pendentes'"
                  (click)="filtrarLembretes('pendentes')">
            Pendentes <span class="perfil-filtro-lembrete-qtd">{{ qtdLembretesPendentes() }}</span>
          </button>
          <button type="button" class="perfil-filtro-lembrete" [class.perfil-filtro-lembrete-ativo]="filtroLembretes() === 'concluidos'"
                  (click)="filtrarLembretes('concluidos')">
            Concluídos <span class="perfil-filtro-lembrete-qtd">{{ qtdLembretesConcluidos() }}</span>
          </button>
          <button type="button" class="perfil-ordenacao-lembrete" (click)="alternarOrdenacaoLembretes()">
            {{ lembretesMaisRecentes() ? 'Mais recentes' : 'Mais antigos' }}
            <img src="./assets/icones/redesign/utils/chevron-bottom.svg" alt="" class="perfil-ordenacao-seta"
                 [class.perfil-ordenacao-seta-invertida]="!lembretesMaisRecentes()" />
          </button>
        </div>

        @for (lembrete of lembretesContato(); track lembrete.id) {
          <app-card-lembrete-contato [lembrete]="lembrete" @surgirHistorico></app-card-lembrete-contato>
        }
        @if (carregandoLembretesContato()) {
          @for (linha of (lembretesContato().length ? [1] : [1, 2, 3]); track linha) {
            <span class="skeleton perfil-skeleton-card perfil-skeleton-lembrete"></span>
          }
        } @else if (lembretesContato().length === 0) {
          <span class="perfil-vazio">{{ filtroLembretes() === 'pendentes' ? 'Nenhum lembrete pendente para este contato.' : 'Nenhum lembrete concluído para este contato.' }}</span>
        }
      </section>
    } @else {
      <section class="perfil-historico">
        @for (item of linhaDoTempo(); track item.sessao.id) {
          @let aberta = sessaoAberta() === item.sessao.id;
          <article class="perfil-sessao" [class.perfil-sessao-aberta]="aberta" @surgirHistorico>
            <div class="perfil-sessao-cabecalho" role="button" tabindex="0" [attr.aria-expanded]="aberta"
                 (click)="alternarSessao(item.sessao.id)" (keydown.enter)="alternarSessao(item.sessao.id)">
              <div class="perfil-sessao-topo">
                <div class="perfil-sessao-identidade">
                  <span class="perfil-sessao-bolinha" [class.perfil-sessao-bolinha-ativa]="item.sessao.ativo"
                        [matTooltip]="item.sessao.ativo ? 'Sessão ativa' : 'Sessão encerrada'"
                        [attr.aria-label]="item.sessao.ativo ? 'Sessão ativa' : 'Sessão encerrada'"></span>
                  <span class="perfil-sessao-titulo">Sessão #{{ item.sessao.id }}</span>
                </div>
                <button type="button" class="perfil-evento-localizar" [disabled]="!item.sessao.dataAbertura"
                        aria-label="Localizar início da sessão no chat" matTooltip="Localizar no chat"
                        (click)="localizarNoChat({ data: item.sessao.dataAbertura }); $event.stopPropagation()">
                  <span class="chat-icone-duplo chat-icone-duplo-ligado">
                    <img src="./assets/icones/redesign/modulos/chat/components-message/go-to-chat.svg" alt="" class="chat-icone-base" />
                    <img src="./assets/icones/redesign/modulos/chat/components-message/go-to-chat-primary.svg" alt="" class="chat-icone-ativo" />
                  </span>
                </button>
              </div>

              <div class="perfil-sessao-metricas">
                <span class="perfil-sessao-metrica">
                  <span class="perfil-sessao-metrica-valor">{{ item.sessao.dataAbertura ? (item.sessao.dataAbertura | date: 'dd/MM HH:mm') : '-' }}</span>
                  <span class="perfil-sessao-metrica-rotulo">Abertura</span>
                </span>
                <span class="perfil-sessao-metrica">
                  <span class="perfil-sessao-metrica-valor">{{ item.duracao }}</span>
                  <span class="perfil-sessao-metrica-rotulo">Duração</span>
                </span>
                <span class="perfil-sessao-metrica">
                  <span class="perfil-sessao-metrica-valor">{{ item.qtdAtendimentos }}</span>
                  <span class="perfil-sessao-metrica-rotulo">{{ item.qtdAtendimentos === 1 ? 'Atendimento' : 'Atendimentos' }}</span>
                </span>
                <img src="./assets/icones/redesign/utils/chevron-bottom.svg" alt="" class="perfil-sessao-seta" />
              </div>
            </div>

            @if (aberta) {
              <div class="perfil-sessao-detalhes" @expandir>
                <dl class="perfil-resumo perfil-sessao-resumo">
                  <dt>Canal</dt><dd>{{ item.sessao.canal?.nome || '-' }}</dd>
                  <dt>Fluxo</dt><dd>{{ item.sessao.fluxo?.nome || '-' }}</dd>
                  <dt>Etapa</dt><dd>{{ item.sessao.etapa?.nome || '-' }}</dd>
                  <dt>Nº. Recepção</dt><dd>{{ numeroRecepcao(item.sessao) }}</dd>
                </dl>

                @if (item.sessao.tags?.length) {
                  <div class="perfil-tags">
                    @for (tag of item.sessao.tags; track $index) {
                      <span class="perfil-tag"><span class="perfil-tag-bolinha"></span>{{ tag }}</span>
                    }
                  </div>
                }

                <span class="perfil-linha-tempo-titulo">Linha do tempo</span>
                <ol class="perfil-linha-tempo">
                  @for (evento of item.eventos; track evento.chave) {
                    <li [class]="'perfil-evento perfil-evento-' + evento.tipo">
                      <span class="perfil-evento-marcador" aria-hidden="true"></span>
                      <div class="perfil-evento-corpo">
                        <div class="perfil-evento-topo">
                          <span class="perfil-evento-titulo">{{ evento.titulo }}</span>
                          <span class="perfil-evento-hora">{{ evento.data | date: 'dd/MM HH:mm' }}</span>
                        </div>
                        @if (evento.pessoa?.nome) {
                          <span class="perfil-evento-pessoa">
                            <app-avatar-pessoa [pessoa]="evento.pessoa" [tamanho]="20"></app-avatar-pessoa>
                            <span class="perfil-evento-pessoa-nome">{{ evento.pessoa?.nome }}</span>
                          </span>
                        }
                        @if (evento.descricao) {
                          <span class="perfil-evento-descricao" [title]="evento.descricao">{{ evento.descricao }}</span>
                        }
                      </div>
                      <button type="button" class="perfil-evento-localizar" matTooltip="Localizar no chat"
                              [attr.aria-label]="'Localizar ' + evento.titulo + ' no chat'" (click)="localizarNoChat(evento.alvo)">
                        <span class="chat-icone-duplo">
                          <img src="./assets/icones/redesign/modulos/chat/components-message/go-to-chat.svg" alt="" class="chat-icone-base" />
                          <img src="./assets/icones/redesign/modulos/chat/components-message/go-to-chat-primary.svg" alt="" class="chat-icone-ativo" />
                        </span>
                      </button>
                    </li>
                  }
                </ol>
              </div>
            }
          </article>
        }
        @if (carregandoHistorico()) {
          @for (linha of [1, 2]; track linha) {
            <span class="skeleton perfil-skeleton-card"></span>
          }
        } @else if (historico().length === 0) {
          <span class="perfil-vazio">Nenhuma sessão encontrada para este contato.</span>
        }
      </section>
    }
  </div>

  @if (sobreposicao(); as tipo) {
    <div class="perfil-sobreposicao" @deslizar>
      @if (tipo === 'transferir') {
        <header class="perfil-sobreposicao-topo">
          <button type="button" class="perfil-btn-icone" aria-label="Voltar para os detalhes" (click)="voltarParaPerfil()">
            <img src="./assets/icones/redesign/button/icon-back-title-button.svg" alt="" class="perfil-icone-voltar" />
          </button>
          <span class="perfil-topo-titulo">Transferir contato</span>
        </header>
        <div class="perfil-conteudo">
          <section class="perfil-transferencia">
            <app-campo-select label="Selecione o Canal" placeholder="Selecione o canal" campo="nome" [habilitarBusca]="true"
                              [lista]="canais()" [carregando]="carregandoCanais()" [ngModel]="canalSelecionado"
                              (selecionarItem)="selecionarCanal($event)"></app-campo-select>
            <app-campo-select label="Transferir Operador" [placeholder]="canalSelecionado?.id && !carregandoOperadores() && operadores().length === 0 ? 'Nenhum operador neste canal' : 'Selecione o operador'" campo="nome" [habilitarBusca]="true"
                              [lista]="operadores()" [carregando]="carregandoOperadores()" [disabled]="!canalSelecionado?.id || (!carregandoOperadores() && operadores().length === 0)"
                              [ngModel]="operadorSelecionado" (selecionarItem)="operadorSelecionado = $event"></app-campo-select>
            <app-campo-select label="Mudar fluxo" placeholder="Selecione o fluxo" campo="titulo" [habilitarBusca]="true"
                              [lista]="fluxos()" [carregando]="carregandoFluxos()" [ngModel]="fluxoSelecionado"
                              (selecionarItem)="selecionarFluxo($event)"></app-campo-select>
            <app-campo-select label="Mudar etapa" placeholder="Selecione a etapa" campo="titulo" [habilitarBusca]="true"
                              [lista]="etapas()" [carregando]="carregandoEtapas()" [ngModel]="etapaSelecionada"
                              (selecionarItem)="selecionarEtapa($event)"></app-campo-select>
          </section>
        </div>
        <footer class="perfil-rodape">
          <button type="button" class="perfil-btn-primario" [disabled]="transferindo()" (click)="transferir()">
            <img src="./assets/icones/redesign/perfil-contato/acao-seta.svg" alt="" class="perfil-seta-branca" />
            {{ transferindo() ? 'Transferindo...' : 'Transferir contato' }}
          </button>
          <button type="button" class="perfil-btn-fechar" (click)="voltarParaPerfil()">Voltar</button>
        </footer>
      } @else {
        <ng-container *ngComponentOutlet="componenteLembrete; injector: injetorLembrete"></ng-container>
      }
    </div>
  }
</div>
